var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cs from '../_util/classNames';
import Item from './item';
import ItemGroup from './item-group';
import SubMenu from './sub-menu';
import omit from '../_util/omit';
import { renderElem } from './util';
import { ConfigConsumer } from '../ConfigProvider';
var themeList = ['light', 'dark'];
var modeList = ['vertical', 'horizontal', 'pop'];
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickMenuItem = function (key) {
            var selectable = _this.props.selectable;
            if (selectable) {
                _this.setState({
                    selectedKeys: [key],
                });
            }
            _this.props.onClickMenuItem && _this.props.onClickMenuItem(key);
        };
        _this.onClickSubMenu = function (key, level) {
            var accordion = _this.props.accordion;
            var openKeys = _this.state.openKeys;
            var newOpenKeys = [];
            if (openKeys.indexOf(key) > -1) {
                if (accordion && level === 1) {
                    newOpenKeys = [];
                }
                else {
                    newOpenKeys = openKeys.filter(function (item) { return item !== key; });
                }
            }
            else if (accordion && level === 1) {
                newOpenKeys = [key];
            }
            else {
                newOpenKeys = openKeys.concat([key]);
            }
            _this.setState({
                openKeys: newOpenKeys,
            }, function () {
                _this.props.onClickSubMenu && _this.props.onClickSubMenu(key, newOpenKeys);
            });
        };
        _this.allOpenKeys = [];
        _this.getOpenKeys = function (key) {
            if (_this.allOpenKeys.indexOf(key) < 0) {
                _this.allOpenKeys.push(key);
            }
        };
        _this.componentDidMount = function () {
            if (_this.state.autoOpen) {
                _this.setState({
                    openKeys: _this.allOpenKeys,
                    autoOpen: false,
                });
            }
        };
        _this.renderMenu = function (_a) {
            var _b;
            var getPrefixCls = _a.getPrefixCls;
            var _c = _this.props, children = _c.children, mode = _c.mode, theme = _c.theme, collapse = _c.collapse, menuPrefixCls = _c.prefixCls, style = _c.style, autoScrollIntoView = _c.autoScrollIntoView, className = _c.className, activeItemBorderDirection = _c.activeItemBorderDirection, triggerProps = _c.triggerProps, icons = _c.icons, rest = __rest(_c, ["children", "mode", "theme", "collapse", "prefixCls", "style", "autoScrollIntoView", "className", "activeItemBorderDirection", "triggerProps", "icons"]);
            var _d = _this.state, openKeys = _d.openKeys, selectedKeys = _d.selectedKeys;
            var wrapperCollapse = _this.context.siderCollapsed ? _this.context.siderCollapsed : collapse;
            var prefixCls = menuPrefixCls || getPrefixCls('menu');
            var classNames = cs(prefixCls, (_b = {},
                _b[prefixCls + "-dark"] = theme === 'dark',
                _b[prefixCls + "-collapse"] = wrapperCollapse,
                _b[prefixCls + "-pop"] = mode === 'pop' || wrapperCollapse,
                _b[prefixCls + "-horizontal"] = mode === 'horizontal',
                _b), className);
            return (React.createElement("div", __assign({}, omit(rest, [
                'autoOpen',
                'accordion',
                'onClickMenuItem',
                'onClickSubMenu',
                'defaultSelectedKeys',
                'defaultOpenKeys',
                'selectedKeys',
                'openKeys',
                'selectable',
                'isMenu',
                'scrollConfig',
            ]), { style: __assign({}, style), className: classNames }), React.Children.map(children, function (child) {
                return renderElem(child, {
                    level: 1,
                    mode: mode,
                    theme: theme,
                    openKeys: openKeys,
                    selectedKeys: selectedKeys,
                    prefixCls: prefixCls,
                    collapse: wrapperCollapse,
                    autoScrollIntoView: autoScrollIntoView,
                    onClickSubMenu: _this.onClickSubMenu,
                    onClickMenuItem: _this.onClickMenuItem,
                    activeItemBorderDirection: activeItemBorderDirection,
                    getOpenKeys: _this.getOpenKeys,
                    triggerProps: triggerProps,
                    icons: icons,
                });
            })));
        };
        _this.state = {
            openKeys: props.openKeys || props.defaultOpenKeys || [],
            selectedKeys: props.selectedKeys || props.defaultSelectedKeys || [],
            autoOpen: Boolean(props.autoOpen),
        };
        return _this;
    }
    // 支持受控模式
    Menu.getDerivedStateFromProps = function (nextProps) {
        var newState = {};
        if ('openKeys' in nextProps && nextProps.openKeys !== undefined) {
            newState.openKeys = nextProps.openKeys;
        }
        if ('selectedKeys' in nextProps && nextProps.selectedKeys !== undefined) {
            newState.selectedKeys = nextProps.selectedKeys;
        }
        if (Object.keys(newState).length > 0) {
            return newState;
        }
        return null;
    };
    Menu.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderMenu);
    };
    Menu.displayName = 'Menu';
    Menu.Item = Item;
    Menu.SubMenu = SubMenu;
    Menu.ItemGroup = ItemGroup;
    Menu.contextTypes = {
        siderCollapsed: PropTypes.bool,
        collapsedWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    };
    Menu.propTypes = {
        accordion: PropTypes.bool,
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        defaultOpenKeys: PropTypes.array,
        defaultSelectedKeys: PropTypes.array,
        openKeys: PropTypes.array,
        selectedKeys: PropTypes.array,
        onClickMenuItem: PropTypes.func,
        onClickSubMenu: PropTypes.func,
        prefixCls: PropTypes.string,
        selectable: PropTypes.bool,
        style: PropTypes.object,
        theme: PropTypes.oneOf(themeList),
        mode: PropTypes.oneOf(modeList),
        autoScrollIntoView: PropTypes.bool,
        scrollConfig: PropTypes.object,
        isMenu: PropTypes.bool,
        collapse: PropTypes.bool,
        activeItemBorderDirection: PropTypes.oneOf(['left', 'right']),
    };
    Menu.defaultProps = {
        accordion: false,
        className: '',
        selectable: true,
        style: {},
        theme: 'light',
        mode: 'vertical',
        collapse: false,
        autoScrollIntoView: false,
        scrollConfig: {},
        isMenu: true,
        activeItemBorderDirection: 'left',
    };
    return Menu;
}(Component));
export default Menu;
